import React, { useEffect, useRef, useState } from 'react';
import { Loading, useNotify, useRedirect } from 'react-admin';

const FetchImage = (props) => {
    const [imageStatus, setImageStatus] = useState(false);
    const [imageStatusError, setImageStatusError] = useState(false);

    const image = useRef();
    const redirect = useRedirect();
    const notify = useNotify();
    const handleImageLoaded = () => {
        setImageStatus(true);
    }

    const handleImageErrored = () => {
        setImageStatusError(true);
        setImageStatus(true);
    }

    async function fetchImageBlob(url, method) {

        const response = await fetch(url, {
            method: method,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem('token')
            }
        });
        if (response.status == 401) redirect('/login');
        const imageBlob = await response.blob();
        return imageBlob;
    }


    useEffect(() => {
        const img = image.current;

        const imageBlob = fetchImageBlob(props.fileDownloadUri, 'GET');

        imageBlob.then((blob) => {
            const imageUrl = URL.createObjectURL(blob);
            img.src = imageUrl;

        }).catch(function (error) {
            notify(error);
        });

    }, []);

    return (
        <div>
            <img ref={image}
                alt="Pièce jointe invisible"
                onLoad={handleImageLoaded}
                onError={handleImageErrored}
                style={{ color: '#1E90FF', cursor: 'pointer', width: 300, height: 150 }} />
            {imageStatus ? null : <Loading style={{ width: 300, height: 150 }} />}
            {imageStatusError ? <p style={{ color: '#FF0000	' }}>Impssible de charger cette image</p> : null}
        </div>
    )
}

export default FetchImage;